import { IconTrashCanLine } from 'utils/SVGIcons';

interface QuantityStepperProps {
  productId: string;
  optionId: string | null;
  isSelected: boolean;
  quantity: number;
  onIncrease: (productId: string, optionId: string | null) => void;
  onDecrease: (productId: string, optionId: string | null) => void;
}

const QuantityStepper = ({
  productId,
  optionId,
  isSelected,
  quantity,
  onIncrease,
  onDecrease,
}: QuantityStepperProps) => {
  return (
    <div className="quantity-stepper">
      <button
        type="button"
        className="stepper-button"
        onClick={() => onDecrease(productId, optionId)}
        disabled={!isSelected || quantity <= 0}
      >
        {isSelected && quantity <= 1 ? <IconTrashCanLine size={16} /> : '−'}
      </button>
      <div className="stepper-value">{isSelected ? quantity : 0}</div>
      <button
        type="button"
        className="stepper-button"
        onClick={() => onIncrease(productId, optionId)}
        disabled={!isSelected}
      >
        +
      </button>
    </div>
  );
};

export default QuantityStepper;
